<template>
  <div
    :class="[
      'row',
      alignFlexItems,
      justifyFlexItems,
      gutter ? `q-col-gutter-${gutter}` : '',
      { reverse: reverse },
    ]"
  >
    <slot />
  </div>
</template>

<script>
/**
 * This component using quasar Grid Row.
 * https://quasar.dev/layout/grid/row
 *
 * [Props]
 * gutter: none, xs, sm, md, lg, xl
 * https://quasar.dev/layout/grid/gutter#Introduction
 *
 * reverse: Flex reverse
 * https://quasar.dev/layout/grid/row#Reordering
 *
 * Horizontal alignment
 * justify~: Flex justify-content
 * https://quasar.dev/layout/grid/row#Example--Horizontal-alignment
 */

export default {
  name: 'Row',
  props: {
    gutter: { type: String },
    reverse: { type: Boolean },
    //Horizontal alignment
    justifyContent: { type: String, default: '' },
    // Vertical alignment
    alignItems: { type: String, default: '' },
  },
  computed: {
    alignFlexItems() {
      let alignment;
      switch (this.alignItems) {
        case 'start':
          alignment = 'items-start';
          break;
        case 'center':
          alignment = 'items-center';
          break;
        case 'end':
          alignment = 'items-end';
          break;
        default:
          alignment = '';
      }
      return alignment;
    },
    justifyFlexItems() {
      let justify;
      switch (this.justifyContent) {
        case 'start':
          justify = 'justify-start';
          break;
        case 'center':
          justify = 'justify-center';
          break;
        case 'end':
          justify = 'justify-end';
          break;
        case 'around':
          justify = 'justify-around';
          break;
        case 'between':
          justify = 'justify-between';
          break;
        default:
          justify = '';
      }
      return justify;
    },
  },
};
</script>
